import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="min-h-screen bg-stone-50 selection:bg-rose-200 selection:text-rose-900 flex flex-col" data-id="element-90">
      <Navbar data-id="element-91" />
      <main className="flex-1" data-id="element-92">{children}</main>
      <Footer data-id="element-93" />
    </div>;
}